import React, { Component } from 'react';
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBInput } from 'mdbreact';

import newVault from '../../../actions/newVault'

import { connect } from 'react-redux'

class ModalPage extends Component {

    state = {
        vault: ''
    }

    submitVault = () => {
        let { vault } = this.state
        let status = this.props.vaults.filter(val => {
            return val === vault
        })
        if (status.length === 0) {
            this.props.newVault(this.state.vault)
            this.props.toggle()
        } else {
            alert(`you already have ${vault} Vault. please fill another onoe`)
        }
    }
    handleChange = (e) => {
        this.setState({
            vault: e.target.value
        })
    }

    render() {
        return (
            <MDBContainer>
                {/* <MDBBtn onClick={this.toggle}>Modal</MDBBtn> */}
                <MDBModal isOpen={this.props.modal} toggle={this.props.toggle}>
                    <MDBModalHeader toggle={this.toggle}><span style={{ color: 'black' }}> Add New Vault</span></MDBModalHeader>
                    <MDBModalBody>
                        <MDBInput onChange={this.handleChange} label="Vault Name" />
                    </MDBModalBody>
                    <MDBModalFooter>
                        <MDBBtn color="secondary" onClick={this.props.toggle}>Close</MDBBtn>
                        <MDBBtn onClick={this.submitVault} color="primary">Save</MDBBtn>
                    </MDBModalFooter>
                </MDBModal>
            </MDBContainer>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        vaults: state.userData.vaults
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        newVault: (vault) => dispatch(newVault(vault))
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(ModalPage);